import React, { Component, Fragment } from "react";
import BpmnModeler from "bpmn-js/lib/Modeler";
// import BpmnModeler from "./custom-modeler";
import propertiesPanelModule from "bpmn-js-properties-panel";
// import propertiesProviderModule from "bpmn-js-properties-panel/lib/provider/bpmn";
import propertiesProviderCamundaModule from "bpmn-js-properties-panel/lib/provider/camunda";

import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda';
// import propertiesProviderModuleTemplates from "bpmn-js-properties-panel/lib/provider/camunda/element-templates";
// import propertiesProviderModuleCmdTemplates from "bpmn-js-properties-panel/lib/provider/camunda/element-templates/cmd";
// import propertiesProviderModule from "./provider/magic";
// import magicModdleDescriptor from "./descriptors/magic";

import ZoomControls from "./components/ZoomControls";
import FileControls from "./components/FileControls";
import EditingTools from './components/EditingTools';

import "./style/app.less";

import fileDialog from "file-dialog";
import fileDownload from "js-file-download";
import moment from "moment";

let scale = 1;

export default class extends Component {
  componentDidMount() {
    // document.body.className = "shown";

    this.bpmnModeler = new BpmnModeler({
      additionalModules: [propertiesPanelModule, propertiesProviderCamundaModule],
      container: "#canvas",
      propertiesPanel: {
        parent: "#properties-panel"
      },
      moddleExtensions: {
        camunda: camundaModdleDescriptor
      }
    });

    // this.bpmnModeler.on('commandStack.changed', this.onChange);

    const xml = '';

    this.renderDiagram(xml);
  }

  componentWillReceiveProps(nextProps) {
    const { xml } = nextProps;
    if (xml && xml !== this.props.xml) {
      this.renderDiagram(xml);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  renderDiagram(xml){
    this.bpmnModeler.importXML(xml, err => {
      if (err) {
        // import failed :-(
        console.log("error rendering", err);
      } else {
        // we did well!
        this.bpmnModeler.getDefinitions()
        console.log("successfully rendered");
      }
    });
  };

  handleSave = (doneFunction) => {
    this.bpmnModeler.saveXML({ format: true }, doneFunction);
  }

  handleRedo = () => {
    this.bpmnModeler.get('commandStack').redo();
  };

  handleUndo = () => {
    this.bpmnModeler.get('commandStack').undo();
  };

  handleZoom = () =>{
    this.bpmnModeler.get('canvas').zoom(scale);
  }

  handleZoomIn = () => {
    scale += 0.1;
    this.handleZoom();
  };

  handleZoomOut = () => {
    if (scale <= 0.3) {
      scale = 0.2
    } else {
      scale -= 0.1;
    };
    this.handleZoom();
  };

  handleZoomReset = () => {
    scale = 1;
    this.handleZoom();
  };

  handleOpen = () => {
    fileDialog().then(files => {
      if(files[0]) {
        const reader = new FileReader();
        reader.readAsText(files[0], "UTF-8");
        reader.onload = (evt) => {
          this.renderDiagram(evt.target.result);
        }
      }
    })
  };

  handleCreate = () => {};

  handleSaveFile = () => {
    this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
      fileDownload(xml, this.bpmnModeler.getDefinitions().rootElements[0].id+'.'+moment(new Date()).format('YYYYMMDD-HHmm')+'.bpmn');
    });
  };

  handleSaveImage = () => {};

  render() {
    return (
      <Fragment>
        <div className="content">
          <div id="canvas" />
          <div id="properties-panel" />
        </div>
        <ZoomControls
          onZoomIn={this.handleZoomIn}
          onZoomOut={this.handleZoomOut}
          onZoomReset={this.handleZoomReset}
        />
        <FileControls
          onOpen={this.handleOpen}
          onCreate={this.handleCreate}
          onSaveFile={this.handleSaveFile}
          onSaveImage={this.handleSaveImage}
        />
        <EditingTools
          onSave={() => this.handleSave(this.props.onSave)}
          onRedo={this.handleRedo}
          onUndo={this.handleUndo}
        />
      </Fragment>
    );
  }
}
